import Table from '../components/rotating-content/compare-table';
import Features from '../components/rotating-content/large-feature-panel';
import DefaultVpaaS from '../components/rotating-content/default-vpaas';
import MarketingPaneVpaas from '../components/rotating-content/marketing-pane-vpaas';
import { getRandomValue } from '../core/utils';
import { isSignUp, isPaid, vpaasMode } from './auth0';
import theme from '../core/theme';
import { setCurrentAdName as setAnalyticsAdName } from './amplitude';

let currentAd;

let PAID_ROTATING_ADS;
let FREE_ROTATING_ADS;
let LOGIN_ROTATING_ADS;
let VPAAS_ADS;

export const setupRotatingAds = () => {
  PAID_ROTATING_ADS = [
    {
      background: theme.defaultBackground,
      template: Table,
      name: 'table',
    },
    {
      background: theme.defaultBackground,
      template: Features,
      name: 'features',
    },
  ];
  FREE_ROTATING_ADS = [
    {
      background: theme.defaultBackground,
      template: Table,
      name: 'table',
    },
    {
      background: theme.defaultBackground,
      template: Features,
      name: 'features',
    },
  ];
  LOGIN_ROTATING_ADS = [
    {
      background: theme.defaultBackground,
      template: Table,
      name: 'table',
    },
    {
      background: theme.defaultBackground,
      template: Features,
      name: 'features',
    },
  ];
  VPAAS_ADS = {
    simple: [{
      background: theme.vpaasMarketingBackground,
      template: MarketingPaneVpaas,
      name: 'vpaas-simple',
    }],
    default: [{
      background: `url('https://vo-cdn.8x8.vc/static/auth0/jaas_default_background.png') no-repeat`,
      template: DefaultVpaaS,
      name: 'vpaas-default',
    }],
  }
}

export const getAdvertisement = () => {
  if (isSignUp()) {
    currentAd = isPaid() ?
      PAID_ROTATING_ADS[getRandomValue(PAID_ROTATING_ADS.length)] :
      FREE_ROTATING_ADS[getRandomValue(FREE_ROTATING_ADS.length)];
  } else {
    currentAd = LOGIN_ROTATING_ADS[getRandomValue(LOGIN_ROTATING_ADS.length)];
  }
  setAnalyticsAdName(currentAd.name);

  return currentAd;
}

export const getAdvertisementVpaaS = () => {
  const vpaasAdds = VPAAS_ADS[vpaasMode()];
  currentAd = vpaasAdds[getRandomValue(vpaasAdds.length)];
  setAnalyticsAdName(currentAd.name);

  return currentAd;
}